import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { Role } from 'src/app/_models';
import { MessService } from 'src/app/_services/mess-service.service';
import { UsersService } from 'src/app/_services/users.service';

@Component({
  selector: 'app-users-add',
  templateUrl: './users-add.component.html',
})
export class UsersAddComponent implements OnInit, OnDestroy {
  roles: any[];
  selectedRole: Role;
  addUserForm: FormGroup;

  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private usersService: UsersService,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.roles = Object.entries(Role)
      .filter((e) => !isNaN(e[0] as any))
      .map((e) => ({ name: e[1], role_id: +e[0] }));
  }

  //  * Lifecycles === //
  ngOnInit(): void {
    this.addUserForm = this.fb.group({
      fname: [''],
      lname: [''],
      username: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      password_confirmation: ['', [Validators.required]],
      role_id: [this.roles[0].role_id, [Validators.required]],
    });

    // * On Change User Role
    this.subscriptions.push(
      this.addUserForm.get('role_id').valueChanges.subscribe({
        next: (value) => {
          if (value && value === Role.radnik) {
            this.addUserForm.get('email').clearValidators();
            this.addUserForm.get('email').updateValueAndValidity();
          } else {
            this.addUserForm
              .get('email')
              .setValidators([Validators.required, Validators.email]);
            this.addUserForm.get('email').updateValueAndValidity();
          }
        },
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Add user === //
  onAddUser() {
    let user = this.addUserForm.getRawValue();
    this.subscriptions.push(
      this.usersService.addUser(user).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno kreiranje',
            detail: 'Uspešno ste dodali novog korisnika.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.addUserForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }
}
